<template>
  <div>
    <div class="form-group row">
      <label :for="this.id" class="col-12 col-lg-4 col-form-label">{{this.label}}</label>
      <div class="col-12 col-lg-8">
        <div class="" :id="this.containerId">
          <div class="yes-no-container">
            <input type="radio" :name="this.id" :id="this.yesId" value="true" class="isOffScreen" @change="$emit('update', $event.target.name, $event.target.value)" :checked="this.value === 'true' || this.value === true">
            <label :for="this.yesId" class="btn btn-default btn-default-hover">Yes</label>
          </div>
          <div class="yes-no-container">
            <input type="radio" :name="this.id" :id="this.noId" value="false" class="isOffScreen" @change="$emit('update', $event.target.name, $event.target.value)" :checked="this.value === 'false' || this.value === false">
            <label :for="this.noId" class="btn btn-default btn-default-hover margin-left-2">No</label>
            
          </div>
          <div class="col-12 yes-no clear-padding-left text-danger error-message" v-show="this.errors.hasKey(this.containerId)"><span class="" v-text="this.errors.getPropByKey('error', this.containerId)"></span></div>
          <Tooltip v-show="this.showTooltip(true, this.helpText)" :helpText="this.helpText" />
        </div>
      </div>
      
    </div>

  </div>
</template>

<script>
import Tooltip from "@/components/controls/Tooltip.vue";
import htmlControlsMixin from "@/mixins/htmlControls";
export default {
  name: "YesNoInput",
  props: ["helpText", "label", "id", "value", "errors", "tooltip"],
  mixins: [htmlControlsMixin],
  components: {
    Tooltip
  },
  data() {
    return {
      key: "value",
      noId: this.id + "N",
      yesId: this.id + "Y",
      containerId: this.id + "_container"
    };
  },
  methods: {},
  mounted() {},
  created(){
  }
};
</script>

<style scoped>
div.is-invalid, .was-validated div:invalid {
     color:  #dc3545;
}
</style>
